module.exports = __webpack_public_path__ + "static/media/left_arrow_orange.39a06429.svg";